import { AuctionStatus } from "../configs/constant";

export const isLiveAuction = (nft) => {
    return  nft?.auction_status === AuctionStatus.ON_AUCTION
            && nft.sell?.auction_end_at * 1000 > nft.currentTime
            && nft.sell?.auction_start_at * 1000 < nft.currentTime;
}